import { apiGet, apiPost, apiPut } from "./apiClient";

const unwrap = response => {
  const payload = response?.data;
  if (!payload?.success) throw new Error(payload?.message || "Communication-channel request failed.");
  return payload.data;
};

export const fetchCommunicationChannels = () => apiGet("/customers/communication-channels").then(unwrap);
export const fetchCustomerCommunicationDefault = customerId => apiGet(`/customers/${customerId}/communication-channel`).then(unwrap);
export const updateCustomerCommunicationDefault = (customerId, payload) => apiPut(`/customers/${customerId}/communication-channel`, payload).then(unwrap);
export const fetchQueryCommunicationChannel = queryPk => apiGet(`/queries/${queryPk}/communication-channel`).then(unwrap);
export const updateQueryCommunicationChannel = (queryPk, payload) => apiPut(`/queries/${queryPk}/communication-channel`, payload).then(unwrap);
export const skipSupplierOutreach = (queryPk, reason) => apiPost(`/queries/${queryPk}/skip-supplier-outreach`, { reason }).then(unwrap);

